import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,Events} from 'ionic-angular';
import {
  DatePipe,
  DecimalPipe
} from '@angular/common';

/**
 * Generated class for the InfoTrackerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-info-tracker',
  templateUrl: 'info-tracker.html',
})
export class InfoTrackerPage {
selectedV : any;
marque : string;
matricule : string;
driver : string;
etat : string;
vitesse : number;
location : string;
lat : any;
lon : any;
signal : any;
moteur : string ;
firstname  : string = "Pas de chauffeur";
lastname : string = "";
  constructor(public navCtrl: NavController, public navParams: NavParams,
  	 public events: Events, private pipe: DecimalPipe,) {
this.selectedV = this.navParams.get('group');
console.log(this.selectedV);
 this.marque = this.selectedV.vehicule.mark;
 this.matricule = this.selectedV.vehicule.matricule;
if (this.selectedV.vehicule.driver){
  if (this.selectedV.vehicule.driver.firstName ==null || this.selectedV.vehicule.driver.firstName ==undefined){
    this.firstname  = "";
  }else{
    this.firstname = this.selectedV.vehicule.driver.firstName;
  }
  if (this.selectedV.vehicule.driver.lastName ==null || this.selectedV.vehicule.driver.lastName ==undefined){
     this.lastname  = "";
  
  }else{
   this.lastname = this.selectedV.vehicule.driver.lastName;
  }
}

 
 this.driver = this.firstname +" "+  this.lastname ;
 this.etat = this.selectedV.vehicule.realTimeRecord.realTimeRecordStatus;
  this.vitesse = this.selectedV.vehicule.realTimeRecord.speed;
   this.location = this.selectedV.vehicule.realTimeRecord.geocoding;
   this.lat = this.PipeLngLat(this.selectedV.vehicule.realTimeRecord.coordinate.lat);
   this.lon = this.PipeLngLat(this.selectedV.vehicule.realTimeRecord.coordinate.lng);
   this.signal = this.selectedV.vehicule.realTimeRecord.signal;
   if (this.selectedV.vehicule.realTimeRecord.ignition){
   	this.moteur = "En marche";}
   	else{
		this.moteur= "En arrêt";
}

//listMapTrajet()
this.events.subscribe('showinfo', selectedV => {
  this.marque = selectedV.vehicule.mark;
 this.matricule = selectedV.vehicule.matricule;

 if (this.selectedV.vehicule.driver){
  if (this.selectedV.vehicule.driver.firstName ==null || this.selectedV.vehicule.driver.firstName ==undefined){
    this.firstname  = "";
  }else{
    this.firstname = this.selectedV.vehicule.driver.firstName;
  }
  if (this.selectedV.vehicule.driver.lastName ==null || this.selectedV.vehicule.driver.lastName ==undefined){
     this.lastname  = "";
  
  }else{
   this.lastname = this.selectedV.vehicule.driver.lastName;
  }
}
 this.driver = this.firstname +" "+  this.lastname ;
 this.etat = selectedV.vehicule.realTimeRecord.realTimeRecordStatus;
  this.vitesse = selectedV.vehicule.realTimeRecord.speed;
   this.location = selectedV.vehicule.realTimeRecord.geocoding;
   this.lat = this.PipeLngLat(selectedV.vehicule.realTimeRecord.coordinate.lat);
   this.lon = this.PipeLngLat(selectedV.vehicule.realTimeRecord.coordinate.lng);
   this.signal = selectedV.vehicule.realTimeRecord.signal;
   if (selectedV.vehicule.realTimeRecord.ignition){
   	this.moteur = "En marche";
}else{
		this.moteur= "En arrêt";
}
});

   
 //console.log(this.marque);
  
  }
PipeLngLat(value: any) {
      return this.pipe.transform(value, '2.2-6');
    }

callOpenmenu(){
this.events.publish("openmenu");
}
  ionViewDidLoad() {
    console.log('ionViewDidLoad InfoTrackerPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/info-tracker/info-tracker.ts